import { render, staticRenderFns } from "./OcorrenciaModal.vue?vue&type=template&id=7e4ebba6&scoped=true"
import script from "./OcorrenciaModal.vue?vue&type=script&lang=js"
export * from "./OcorrenciaModal.vue?vue&type=script&lang=js"
import style0 from "./OcorrenciaModal.vue?vue&type=style&index=0&id=7e4ebba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4ebba6",
  null
  
)

export default component.exports